import { IEnvironment } from './environment.type';
import { environment as baseEnvironment } from './environment';

export const productionEnvironment: IEnvironment = {
  ...baseEnvironment,
  host: 'https://makaniparking.app',
  baseUrl: 'https://makaniparking.app',
  apiUrl: 'https://api.makaniparking.app/api/v1/',
  apiUrl_v1: 'https://api.makaniparking.app/api/v1',
  meetingUrl: 'https://meet.availy.net',
  hubUrl: 'https://api.makaniparking.app/hub/v1/notifications',
  production: true,
  userAgent: 'life-digital-portal',
  userAgentSecret: 'life-digital-portal-O1zH7GsTlC3AvxRJ1NdkfiaZm8lO1R61N1CibKg=',
  useInMemoryClients: false
};

export const environment: IEnvironment = productionEnvironment;
